import { render, staticRenderFns } from "./mapGlobalConfig.vue?vue&type=template&id=9f998370"
import script from "./mapGlobalConfig.vue?vue&type=script&lang=js"
export * from "./mapGlobalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports